
























































































































import { Component, Prop, Vue } from "vue-property-decorator";
import ModalHeader from "@/components/ModalHeader.vue";
import { VueEditor } from "vue2-editor";
import { CaseLogEntry } from "@/store/modules/types";
import { CaseLogType } from "@/store/modules/enums";
import { randomId } from "@/utils";

@Component({
  components: {
    ModalHeader,
    VueEditor,
  },
})
export default class LogViewer extends Vue {
  @Prop() readonly caseId!: string;
  log: Array<any> = [];
  comment = "";
  quill = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
    ],
  };
  async getLog() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { caseId } = this;
      this.log = await this.$store.dispatch("cases/getLog", { caseId });
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async saveComment() {
    if (!this.comment) return;
    const { caseId, comment } = this;
    const entry: CaseLogEntry = {
      caseId,
      typeId: CaseLogType.OFFICE_COMMENT,
      comment,
    };
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("cases/saveLog", entry);
      this.getLog();
      this.comment = "";
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async markRead(log) {
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("cases/markLogRead", log.id);
      this.getLog();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  get unreadComments() {
    return this.log.filter((row) => {
      return !row.isRead && row.typeId === CaseLogType.PATIENT_COMMENT;
    });
  }
  mounted() {
    this.getLog();
  }
}
